<template>
  <div class="form-group form-row">
    <label :for="safeId()" class="col-sm-4 col-form-label" v-if="label">{{ label }}</label>
    <div :class="{'col-sm-8': label, 'col-sm-12': !label}">
      <input type="text" class="form-control" :id="safeId()" v-model.lazy="localValue">
    </div>
  </div>
</template>

<script>
  function format (value) {
    let time = new Date(value)

    let milliseconds = ('000' + (value % 1000)).slice(-3)
    if (value < 60 * 60 * 1000) {
      // Less than one hour
      return time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2) + '.' + milliseconds
    } else {
      // Greater or equal one hour
      return time.getUTCHours() + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + ('0' + time.getSeconds()).slice(-2) + '.' + milliseconds
    }
  }

  function parse (s) {
    let parts = s.split('.')
    const milliseconds = parseInt(parts[1]) || 0
    parts = parts[0].split(':').reverse()
    const result = (parseInt(parts[0]) || 0) + (parseInt(parts[1]) || 0) * 60 + (parseInt(parts[2]) || 0) * 3600
    return result * 1000 + milliseconds
  }

  export default {
    name: 'time-input-group',
    props: ['label', 'value'],
    data () {
      return {
        localValue: format(this.value)
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', parse(val))
      },
      value: function (val) {
        this.localValue = format(val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/time-input-group.vue